import{createStyles as t}from"../../../../../../theme/utils/create-styles.js";var e=t({root:{}});export{e as styles};
